function campaignPayload(link) {
  const destination = new URL(link.href, window.location.origin);

  return {
    campaign_id: link.dataset.campaignId || '',
    placement: link.dataset.campaignPlacement || '',
    position: Number(link.dataset.campaignPosition) || 0,
    destination_path: destination.origin === window.location.origin ? destination.pathname : '',
  };
}

function publishEvent(name, payload) {
  const publish = window.Shopify?.analytics?.publish;
  if (typeof publish !== 'function') return;

  try {
    publish(name, payload);
  } catch {
    // Analytics must never interrupt navigation or purchasing.
  }
}

function publishCampaignEvent(name, link) {
  publishEvent(name, campaignPayload(link));
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-ximena-campaign]');
  if (link) {
    publishCampaignEvent('ximena_campaign_clicked', link);
  }
});

document.addEventListener('ximena:checkout-started', (event) => {
  const allowedSources = ['cart', 'drawer', 'product'];
  const source = allowedSources.includes(event.detail?.source) ? event.detail.source : 'unknown';
  publishEvent('ximena_checkout_started', { source });
});

document.addEventListener('submit', (event) => {
  if (!(event.target instanceof HTMLFormElement)) return;
  const action = new URL(event.target.action, window.location.origin);
  if (action.pathname !== '/search') return;

  publishEvent('ximena_search_submitted', {
    source: event.target.closest('.ximena-header__search') ? 'header' : 'results',
  });
});

document.addEventListener('change', (event) => {
  if (!(event.target instanceof Element) || !event.target.closest('facet-filters-form')) return;
  if (event.target.getAttribute('name') === 'sort_by') return;
  publishEvent('ximena_filter_used', {
    surface: window.location.pathname.startsWith('/search') ? 'search' : 'collection',
  });
});

const campaignObserver = new IntersectionObserver((entries, observer) => {
  for (const entry of entries) {
    if (!entry.isIntersecting || entry.intersectionRatio < 0.5) continue;
    publishCampaignEvent('ximena_campaign_viewed', entry.target);
    observer.unobserve(entry.target);
  }
}, { threshold: 0.5 });

for (const link of document.querySelectorAll('[data-ximena-campaign]')) campaignObserver.observe(link);

const searchResults = document.querySelector('[data-search-results-count]');
if (searchResults) {
  const resultCount = Number(searchResults.dataset.searchResultsCount) || 0;
  publishEvent('ximena_search_results_viewed', { result_count: resultCount, has_results: resultCount > 0 });
}
